import { defaultBridgeBuilder } from '@xigua/app-bridge';

const app = defaultBridgeBuilder.build({});

export default app;

/**
 * @return {boolean}
 */
export function isTouchScreen() {
  return document.ontouchstart !== undefined;
}
